import type { HttpError, RequestError } from '~shared/api/errors';

import type { OrderParams } from '../product';

const productValidationErrors = ['SUM_TOO_LOW', 'SUM_TOO_HIGH'] as const;
export type ProductValidationErrorCode =
  (typeof productValidationErrors)[number];

export type ProductValidationError = HttpError & {
  code: ProductValidationErrorCode;
  body: OrderParams;
};

export function isProductValidationError(
  error: RequestError
): error is ProductValidationError {
  return (
    'code' in error &&
    typeof error.code === 'string' &&
    productValidationErrors.includes(error.code as any)
  );
}
